import React from 'react';
import { Modal } from 'carbon-components-react';
import { phoneNumberFormatter } from 'utilities/validation';

export const OrganisationContactsModal: React.FC<Props | any> = (
  props: Props
) => {
  const { modalOpen, selectedReferralObj, handleCloseClick } = props;

  const handleContactClick = (type: string, val: string) => {
    if (val) {
      const anchor = document.createElement('a');
      switch (type) {
        case 'phone':
          anchor.href = `tel:${val}`;
          anchor.target = '_parent';
          anchor.click();
          break;
        case 'web':
          anchor.href = val;
          anchor.target = '_blank';
          anchor.click();
          break;
        case 'email':
          anchor.href = `mailTo:${val}`;
          anchor.target = '_parent';
          anchor.click();
          break;
      }
      handleCloseClick();
    }
  };

  return (
    <div
      id="OrganisationContactsModal"
      className="organisation-contacts-modal-container"
    >
      <Modal
        passiveModal
        className="organisation-contacts-modal"
        open={modalOpen}
        size="xs"
        modalHeading={'Contact'}
        onRequestClose={handleCloseClick}
      >
        <div className="organisation-contacts-modal-content">
          {selectedReferralObj?.contactPhoneNumber && (
            <div
              className="contact-item"
              onClick={() =>
                handleContactClick(
                  'phone',
                  selectedReferralObj.contactPhoneNumber
                )
              }
            >
              <div>PHONE (GENERAL)</div>
              <div>
                {phoneNumberFormatter({
                  phoneNumber: selectedReferralObj.contactPhoneNumber
                }).getNationalNumberFormat()}
              </div>
              {(selectedReferralObj?.contactEmail ||
                selectedReferralObj?.contactUrl ||
                selectedReferralObj?.contactEmergencyPhone) && (
                <div className="contact-border" />
              )}
            </div>
          )}

          {selectedReferralObj?.contactEmail && (
            <div
              className="contact-item"
              onClick={() =>
                handleContactClick('email', selectedReferralObj.contactEmail)
              }
            >
              <div>EMAIL (GENERAL)</div>
              <div>{selectedReferralObj?.contactEmail}</div>
              {(selectedReferralObj?.contactUrl ||
                selectedReferralObj?.contactEmergencyPhone) && (
                <div className="contact-border" />
              )}
            </div>
          )}

          {selectedReferralObj?.contactUrl && (
            <div
              className="contact-item"
              onClick={() =>
                handleContactClick('web', selectedReferralObj.contactUrl)
              }
            >
              <div>WEB (GENERAL)</div>
              <div>Opens in a new tab</div>
              {selectedReferralObj?.contactEmergencyPhone && (
                <div className="contact-border" />
              )}
            </div>
          )}

          {selectedReferralObj?.contactEmergencyPhone && (
            <div
              className="contact-list-red"
              onClick={() =>
                handleContactClick(
                  'phone',
                  selectedReferralObj.contactEmergencyPhone
                )
              }
            >
              <div>EMERGENCY</div>
              <div>
                {phoneNumberFormatter({
                  phoneNumber: selectedReferralObj.contactEmergencyPhone
                }).getNationalNumberFormat()}
              </div>
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
};

type ownProps = {
  modalOpen: boolean;
  selectedReferralObj: any;
  handleCloseClick: any;
};

type Props = ownProps;

OrganisationContactsModal.displayName = 'OrganisationContactsModal';

export default React.memo(OrganisationContactsModal);
